<template>
  <div v-cloak class="view-wrap">
    <div class="view-content">
      <section class="smaller">
        <div class="section-inner">
          <div class="container">
            <portal-bear v-if="!isLoggedIn"></portal-bear>
            <img v-else class="app-icon" src="~@/images/tb-icon.svg" alt="">
            <div class="element small centered">
              <div v-if="isLoggedIn"  class="text-center">
                <template v-if="admin">
                  <h1 class="h2">Convert your account?</h1>
                  <p>Your personal TunnelBear account <span v-if="email">(<strong>{{email}}</strong>)</span> will be used to register for your team.</p>
                  <p>Any unused credit from your personal account will be refunded, and your 7 day free trial for your team will begin.</p>
                  <router-link :to="{ name: 'start' }" class="btn btn-lg submit-btn">Create your team</router-link>
                  <p>Or <button @click="logout()" class="btn plain link">sign up with a different email</button></p>
                </template>
                <template v-else>
                  <h1 class="h2">Join your team. Protect your&nbsp;data.</h1>
                  <p>You have been invited to join TunnelBear for Teams by {{ teamName.replace(/\+/g, ' ') }}.</p>
                  <p>{{ email }}</p>
                  <p v-if="errorMessage" class="alert alert-danger">{{errorMessage}}</p>
                  <submit-button @submit="join" :finished="finished">Join Team</submit-button>
                  <p>Or go to your <a href="/account">personal account</a></p>
                </template>
              </div>
              <div v-else class="text-center">
                <template v-if="admin">
                  <h1 class="h3">Protect your team. Secure your&nbsp;data.</h1>
                  <p>As your team's owner, you can manage billing, add new users, and even assign administrators.</p>
                </template>
                <template v-else>
                  <h1 class="h2">Join your team. Protect your&nbsp;data.</h1>
                  <p>You have been invited to join TunnelBear for Teams by {{ teamName.replace(/\+/g, ' ') }}.</p>
                  <p>Create a TunnelBear account now to get&nbsp;started.</p>
                </template>
                <div class="portal-wrap">
                  <login-signup-form :email="email" :persistentEmail="inviteEmail" :domain="onboardInfo.domain">
                    <span v-if="admin">Get started for free</span>
                    <span v-else>Join Team</span>
                  </login-signup-form>
                </div>
              </div>
            </div>
            <div v-if="admin" class="element large centered text-center">
              <div class="wirecutter">
                <div class="copy">
                  <p class="quote">
                    For protecting your information on public Wi-Fi, TunnelBear is the most transparent
                    and trustworthy provider offering fast, secure connections and easy setup.
                  </p>
                  <span>- Wirecutter (A New York Times Company)</span>
                </div>
                <img src="./images/wirecutter.svg" alt="Wirecutter pick">
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import loginSignup from '@/components/login-signup-form/login-signup-form'
import portalBear from '@/components/portal-bear/portal-bear'
import Cookies from 'js-cookie'
import submitButton from '@/components/submit-button/submit-button'

export default {
  name: 'entry',
  components: {
    'login-signup-form': loginSignup,
    'portal-bear': portalBear,
    'submit-button': submitButton
  },
  data () {
    return {
      isLoggedIn: this.$store.state.isLoggedIn,
      submitting: false,
      admin: this.$route.path === '/create',
      finished: false,
      errorMessage: '',
      loginView: false,
      existingEmail: '',
      onboardInfo: Cookies.getJSON('TB4T') || { domain: '' }
    }
  },
  created: function () {
    this.watcher = this.$store.watch((state, getters) => getters.isLoggedIn, () => {
      if (this.$store.state.teamData.teamName) {
        if (this.$store.state.teamData.teamRole === 'ADMIN') {
          this.$router.push({ name: 'overview' })
        } else {
          this.$router.push({ name: 'new-team' })
        }
      } else if (this.admin) {
        this.$router.push({ name: 'name' })
      } else {
        this.join()
      }
    })
  },
  computed: {
    email: function () {
      let email = ''
      if (this.$store.getters.isLoggedIn && this.$store.getters.userData) {
        email = this.$store.getters.userData.email
      }
      return email
    },
    currentUser: function () {
      return this.$store.getters.userData
    },
    teamName: function () {
      let name = ''
      let teamInfo = Cookies.getJSON('TB4T')
      if (teamInfo && teamInfo.team) {
        name = teamInfo.team
      }
      return name
    },
    inviteEmail: function () {
      let email = ''
      if (!this.admin && this.onboardInfo.email) {
        email = this.onboardInfo.email
      }
      return email
    }
  },
  methods: {
    join: function () {
      if (this.$store.getters.submitting) return
      this.errorMessage = ''
      this.$store.dispatch('submitting', true)
      this.$http.post(this.ENV.paymentBaseUrl + '/team/addMember').then((response) => {
        this.$store.dispatch('getUserData', true).then(() => {
          if (this.onboardInfo.domain && this.currentUser.bearType) {
            this.$router.push({ name: 'confirm-email' })
          } else {
            this.$router.push({ name: 'success' })
          }
          this.$store.dispatch('submitting', false)
          this.finished = true
        }).catch(() => {
          this.$router.push({ name: 'success' })
          this.$store.dispatch('submitting', false)
          this.finished = true
        })
      }).catch(() => {
        this.$store.dispatch('submitting', false)
        this.errorMessage = 'Grr... There was an issue adding you to the team.'
      })
    },
    logout: function () {
      let redirectPath = this.admin ? '/team/create' : '/team/join'
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ path: redirectPath })
      })
    }
  },
  beforeMount: function () {}
}
</script>

<style scoped lang="stylus" src="./entry.styl" >



// WEBPACK FOOTER //
// src/views/entry/entry.vue